<template>
  <div class="hello">
    <!--ヘッダーここから-->
    <IndexHeader :title="title" />
    <!--TOP画面 ここから-->
    <div class="container">
      <ol class="mokuji">
        <Toc v-for="(q, idx) in drillList" :key="`title${idx}`" @click.native="start(idx)" :q="q" :cid="cid" />
      </ol>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Toc from '@/components/parts/IndexToc.vue'

import IndexHeader from '@/components/parts/IndexHeader.vue'

export default {
  name: "Index",
  components: {
    Toc, IndexHeader
  },
  data() {
    return {
      public: process.env.BASE_URL,
    }
  },
  computed: {
    drillList() {
      return this.$store.state.drills;
    },
    setting() {
      return this.$store.state.setting;
    },
    title() {
      if (this.setting) {
        return this.setting.title.split('\n').join("<br>")
      }
      return null;
    },
    cid() {
      if (this.setting.id) {
        return this.setting.id;
      }
      return null;
    }
  },
  methods: {
    start(idx) {
      this.$store.commit('startQuestion', idx); 
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>
